export default function getAsOfBackgroundColor(
  readOnly: boolean,
  mode: 'ViewEdit' | 'NewEntity' | 'NewAsOf' | null
) {
  if (mode === 'NewAsOf' || mode === 'NewEntity') return 'warning';
  if (readOnly) return 'disabled';
  return 'info';
}
